import React from "react";
export default function PatientSummary({patient = {}}) {
    const value = (v) => {
        if (v === undefined || v === null || v === "") {
            return "-";
        }
        return v;
    };
    return (
        <div className="card-body">

            <table className="table-erp-modern">

                <tbody>

                <tr>
                    <th width="40%">Name</th>
                    <td>{value(patient.patient)}</td>
                </tr>

                <tr>
                    <th>Gender</th>
                    <td>{value(patient.gender)}</td>
                </tr>

                <tr>
                    <th>Date of Birth</th>
                    <td>{value(patient.dob)}</td>
                </tr>

                <tr>
                    <th>Age</th>
                    <td>{value(patient.age)}</td>
                </tr>

                <tr>
                    <th>Mobile</th>
                    <td>{value(patient.mobile)}</td>
                </tr>

                <tr>
                    <th>Address</th>
                    <td>{value(patient.address1)}</td>
                </tr>

                <tr>
                    <th>City</th>
                    <td>{value(patient.city)}</td>
                </tr>

                <tr>
                    <th>State</th>
                    <td>{value(patient.state)}</td>
                </tr>

                <tr>
                    <th>Country</th>
                    <td>{value(patient.country)}</td>
                </tr>

                {/*<tr>*/}
                {/*    <th>Email</th>*/}
                {/*    <td>{value(patient.email)}</td>*/}
                {/*</tr>*/}

                {/*<tr>*/}
                {/*    <th>ABHA No.</th>*/}
                {/*    <td>{value(patient.abha)}</td>*/}
                {/*</tr>*/}

                </tbody>

            </table>

        </div>
    );
}